/* Stylesheet */

.user_menu {
  .menu_container {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 75%;
    background: var(--ion-gradient-dark);
    transform-origin: 100% 0%;
    border-radius: 20% 0% 0% 20% / 90% 0% 0% 100%;
    z-index: 100;
    box-shadow: var(--ion-box-shadow);

    .wrapper_container {
      margin: 0 auto;
      margin-top: 72px;
      width: 65%;
    }
  }
}

.backdrop {
  position: fixed;
  opacity: 0.15;
  background: #000000;
  z-index: 100;
}

/* Media Queries */
@media screen and (min-width: 576px) {
  .user_menu {
    .menu_container {
      width: 70%;
    }
  }
}

@media screen and (min-width: 768px) {
  .user_menu {
    .menu_container {
      width: 60%;
    }
  }
}

@media screen and (min-width: 992px) {
  .user_menu {
    .menu_container {
      width: 45%;
    }
  }
}

@media screen and (min-width: 1200px) {
  .user_menu {
    .menu_container {
      width: 30%;
    }
  }
}
